import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FocoItem, FocoResponse } from '../models/foco';
import { ProductResult } from '../models/product-result';
import { tap } from 'rxjs/operators';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class FocoService {
  private readonly GET_URL = `${environment.apiUrl}/foco`;
  private readonly SEARCH_URL = `${environment.apiUrl}/portfolio/websearch`;
  private readonly SEARCH_ALL_URL = `${environment.apiUrl}/portfolio/focoproductsearch`;
  private readonly POST_URL = `${environment.apiUrl}/foco/create`;
  focoUpdated = new EventEmitter<void>();

  constructor(private httpClient: HttpClient) {}

  getProducts(
    term: string,
    sortBy: string,
    sortDirection: string,
    skip: string,
    take: string
  ) {
    const params = new HttpParams()
      .set('skip', `${skip}`)
      .set('take', `${take}`)
      .set('sortDirection', `${sortDirection}`)
      .set('sortBy', `${sortBy}`)
      .set('value', `${term}`);

    return this.httpClient.get<ProductResult>(this.SEARCH_ALL_URL, {
      params,
    });
  }

  getPortfolioAlternatives(
    term: string,
    sortBy: string,
    sortDirection: string,
    skip: string,
    take: string
  ) {
    const params = new HttpParams()
      .set('skip', `${skip}`)
      .set('take', `${take}`)
      .set('sortDirection', `${sortDirection}`)
      .set('sortBy', `${sortBy}`)
      .set('value', `${term}`);

    return this.httpClient.get<ProductResult>(this.SEARCH_URL, {
      params,
    });
  }

  getFoco(selectedAnf?: string, selectedDate?: Date): Observable<FocoResponse> {
    // Convert selectedDate to ISO string
    const selectedDateString = selectedDate
      ? selectedDate.toISOString()
      : new Date().toISOString();

    // Convert selectedAnf to an integer
    const selectedAnfInt = selectedAnf ? parseInt(selectedAnf, 10) : 0;

    // Create HttpParams and set selectedAnf and selectedDate
    const params = new HttpParams()
      .set('codigoAnf', selectedAnfInt.toString())
      .set('date', selectedDateString);

    return this.httpClient.get<FocoResponse>(this.GET_URL, { params });
  }

  updateFoco(item: FocoItem): Observable<FocoItem> {
    // console.log('Item: ' + item);
    const PUT_URL = `${this.GET_URL}/${item.id}`;
    return this.httpClient.put<FocoItem>(PUT_URL, item, httpOptions).pipe(
      tap(() => this.focoUpdated.emit())
    );
  }

  postFocoItem(
    payload: Partial<FocoItem>,
    selectedAnf: string,
    selectedMonth?: Date
  ) {
    const updatedPayload = {
      ...payload,
      Anomes: selectedMonth
        ? new Date(
            Date.UTC(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1)
          )
        : undefined,
      Farmacia: {
        CodigoAnf: selectedAnf,
      },
    };

    // console.log(updatedPayload);

    return this.httpClient.post<FocoItem>(
      this.POST_URL,
      updatedPayload,
      httpOptions
    );
  }

  deleteFocoItem(id: number) {
    const DELETE_URL = `${this.GET_URL}/${id}`;
    return this.httpClient.delete(DELETE_URL, httpOptions).pipe(
      tap(() => this.focoUpdated.emit())
    );
  }


}
